import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {Form, Input, Radio} from 'antd'
import Button from 'components/shared/Button'

const SharingForm = ({isSubmitting, estateSeller, handleSubmit}) => {
  const [form] = Form.useForm()
  const [, forceUpdate] = useState() // To disable submit button at the beginning.
  useEffect(() => {
    forceUpdate({})
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  function onSubmit(values) {
    handleSubmit({
      ...values,
      includeNotPurchasedProducts: values.includeNotPurchasedProducts === 'true',
    }, form)
  }

  function sharingMethodChanged(previousValues, currentValues) {
    return previousValues.sharingMethod !== currentValues.sharingMethod
  }

  function submitDisabled() {
    const disabled = (
      Object.values(form.getFieldsValue()).some(v => !v) || // luckily all fields are mandatory
      form.getFieldsError().filter(({errors}) => errors.length).length > 0 ||
      isSubmitting
    )
    return disabled
  }

  function setDefaultEstateSeller() {
    form.setFieldsValue({
      recipientName: estateSeller.name,
      recipientEmail: estateSeller.email,
      recipientPhone: estateSeller.phone,
    })
  }

  return (
    <Form
      form={form}
      layout="vertical"
      initialValues={{includeNotPurchasedProducts: 'false', sharingMethod: 'email'}}
      onFinish={onSubmit}
    >
      <Form.Item
        name="includeNotPurchasedProducts"
        label="Hva vil du dele?"
        rules={[{required: true, message: 'Hva du vil dele er påkrevd'}]}
      >
        <Radio.Group>
          <Radio value="true">Del alle produkter</Radio>
          <Radio value="false">Del kun kjøpte produkter</Radio>
        </Radio.Group>
      </Form.Item>

      <Form.Item
        name="sharingMethod"
        label="Hvordan vil du dele?"
        rules={[{required: true, message: 'Hvordan du vil dele er påkrevd'}]}
      >
        <Radio.Group>
          <Radio value="email">E-post</Radio>
          <Radio value="sms">SMS</Radio>
        </Radio.Group>
      </Form.Item>

      {!!estateSeller && (
        <Form.Item>
          <Button onClick={setDefaultEstateSeller}>
            Bruk boligselgers kontaktinformasjon
          </Button>
        </Form.Item>
      )}

      <Form.Item
        name="recipientName"
        label="Mottakers navn"
        rules={[{required: true, message: 'Navn er påkrevd'}]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        noStyle
        shouldUpdate={sharingMethodChanged}
      >
        {({ getFieldValue }) => {
          if (getFieldValue('sharingMethod') === 'email') {
            return (
              <Form.Item
                name="recipientEmail"
                label="Mottakers e-post"
                rules={[
                  {required: true, message: 'E-post er påkrevd'},
                  {type: 'email', message: 'E-post er ikke gyldig'}
                ]}
              >
                <Input />
              </Form.Item>
            )
          } else {
            return (
              <Form.Item
                name="recipientPhone"
                label="Mottakers mobilnummer"
                rules={[
                  {required: true, message: 'Mobilnummer er påkrevd'},
                  {pattern: /^\d{8}$/, message: 'Mobilnummer er ikke gyldig'}
                ]}
              >
                <Input />
              </Form.Item>
            )
          }
        }}
      </Form.Item>
      <Form.Item
        name="messageForRecipient"
        label="Beskjed til mottaker"
        rules={[{required: true, message: 'Beskjed er påkrevd'}]}
      >
        <Input.TextArea autosize={{minRows: 2}} />
      </Form.Item>

      <Form.Item shouldUpdate>
        {() => (
          <Button
            type="action"
            htmlType="submit"
            loading={isSubmitting}
            disabled={submitDisabled()}
          >
            Del produkter
          </Button>
        )}
      </Form.Item>
    </Form>
  )
}

SharingForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
  estateSeller: PropTypes.object,
}

export default SharingForm
